import React, { useEffect, useState } from 'react'
import { getColumnDefs } from './Constant';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import EditIcon from '@mui/icons-material/Edit';
import TableCellTooltip from '../../../common/TableCellTooltip';
import * as mdt from '../../../common/modaltypes';
import { useTranslation } from '../../../../i18n/I18nProvider';
const CopanySettingTable = (props) => {
    const { translations } = useTranslation()
    const mtpl = translations?.mtplMaster || {}
    const columnDefs = getColumnDefs(mtpl)
    const { setSelEditLuggageSetting, updateModal, companiesListAllForMTPLMasterData } = props
    const [selModalRow, setSelModalRow] = useState('');
    const [reportData, setReportData] = useState([]);
    const [tableData, setTableData] = useState(reportData)
    const [filterValues, setFilterValues] = useState({});
    useEffect(() => {
        const data = companiesListAllForMTPLMasterData?.map((val, index) => ({ ...val, srNo: index + 1 }))
        setReportData(data)
    }, [companiesListAllForMTPLMasterData])
    useEffect(() => {
        const areFiltersEmpty = Object.values(filterValues).every(value => value === "" || value === undefined);
        if (areFiltersEmpty) {
            setTableData(reportData);
            return;
        }
        const filteredDataTemp = reportData.filter((item) => {
            return columnDefs?.every((column) => {
                const filterValue = filterValues[column.field];
                const value = item[column.field];
                if (filterValue !== undefined && filterValue !== "") {
                    return value != null && value.toString().toLowerCase().includes(filterValue.toString().toLowerCase());
                }
                return true;
            });
        });
        setTableData(filteredDataTemp);
    }, [filterValues, reportData]);

    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    };
    return (
        <>
            <TableContainer className='scrollBlue' component={Paper} sx={{ maxHeight: '70vh', marginBottom: "5px" }}>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <TableHead sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
                        <TableRow>
                            {columnDefs.map((col, index) => (
                                <TableCell key={`TH-${index}`} sx={{ ...col.headerSx, backgroundColor: '#DAEDFE', padding: '8px 6px !important', minHeight: '36px !important', fontSize: '12px', fontWeight: '700', color: '#444' }}>
                                    {col.headerName}
                                </TableCell>
                            ))}
                        </TableRow>
                        <TableRow sx={{ '& .MuiTableCell-root': { padding: '6px !important' } }}>
                            {columnDefs.map((col, index) => (
                                col.showfilter ? (
                                    <TableCell key={`FTH-${index}`}>
                                        <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                                            <input
                                                id={`Contains-${index}`}
                                                className="field"
                                                value={filterValues[col.field]}
                                                name="cancelSearchInput"
                                                style={{ width: '100%' }}
                                                placeholder={mtpl.contains || 'Contains'}
                                                onChange={(e) => handleChangeContain(e, col.field)}
                                            // onKeyDown={(e) => keyboardNavigation(e, index === 1 ? "createBtn" : `Contains-${index - 1}`, index === 11 ? reportData.length > 0 ? `Edit-0` : 'status' : `Contains-${index + 1}`)}
                                            />
                                            <FilterAltIcon sx={{ paddingRight: '0px !important', color: '#aaa !important' }} />
                                        </div>
                                    </TableCell>
                                ) : <TableCell key={`FTH-${index}`}></TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ '& .MuiTableCell-root': { padding: '6px !important' } }}>
                        {tableData.map((val, index) => (
                            <TableRow key={`DR-${index}`}>
                                <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{index + 1}</TableCell>
                                <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.CompanyID}</TableCell>
                                <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.CompanyCode}</TableCell>
                                <TableCellTooltip title={val.CompanyName} data={val.CompanyName} placement={'bottom-start'} textAlign={"left"} maxWidth={'15%'} />
                                <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.CityName}</TableCell>
                                <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.StateName}</TableCell>
                                <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.RegionName}</TableCell>
                                <TableCellTooltip title={val.B2BManagerEmail} data={val.B2BManagerEmail} placement={'bottom-start'} textAlign={"left"} maxWidth={'100px'} />
                                <TableCellTooltip title={val.OPSManagerEmail} data={val.OPSManagerEmail} placement={'bottom-start'} textAlign={"left"} maxWidth={'100px'} />
                                <TableCellTooltip title={val.NoofBranches} data={val.NoofBranches} placement={'bottom-start'} textAlign={"left"} maxWidth={'100px'} />
                                <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: val.STATUS == 'Active' ? 'green' : 'red' }}>
                                    {val.STATUS === 'Active' ? (mtpl.active || val.STATUS) : (mtpl.inActive || val.STATUS)}
                                </TableCell>
                                <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#666', cursor: "pointer" }}>
                                    <span
                                        id={`Edit-${index}`} tabIndex={0}
                                        style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold' }}
                                        onClick={() => {
                                            setSelModalRow(index);
                                            setSelEditLuggageSetting(val);
                                            updateModal(true, mdt.companyLuggageSettingModel);
                                        }}
                                    >
                                        <EditIcon sx={{ marginRight: '3px' }} />
                                        {mtpl.edit || 'Edit'}
                                    </span>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}

export default CopanySettingTable